const now = new Date();
export const TODAY = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

export const STATUS = {
  todo: { label: "待處理", color: "#5f5b4f", bg: "#ECEFEE" },
  doing: { label: "製作中", color: "#31658f", bg: "#DDEAF4" },
  done: { label: "已完成", color: "#3f712d", bg: "#E1EFDA" }
};

export const TYPES = {
  recording: { label: "全程錄影", short: "錄影", color: "#5965d8", grad: "linear-gradient(155deg,#9fa6ff,#b3bae8)" },
  editing: { label: "剪輯影片", short: "剪輯", color: "#31658f", grad: "linear-gradient(155deg,#6883a1,#97a9b9)" },
  photos: { label: "告別式照片", short: "照片", color: "#4f7d3a", grad: "linear-gradient(155deg,#8cb184,#aec7b0)" }
};

export const TYPE_ORDER = ["recording", "editing", "photos"];
export const STATUS_ORDER = ["todo", "doing", "done"];

export const TITLES = {
  dashboard: ["儀表板", "今日待辦、未完成提醒與案件統計概覽"],
  cases: ["案件管理", "所有影像案件一覽與查詢"],
  newcase: ["案件建檔", "建立新的影像紀錄案件"],
  kanban: ["處理進度", "每一份影像，從拍攝到交付"],
  staff: ["禮儀師查詢", "依禮儀師檢視承接案件與績效"],
  monthly: ["月報表", "單月案件明細與統計"],
  annual: ["年度統計", "全年度案件數與分布"],
  settings: ["下拉選單設定", "管理建檔表單的選項內容"]
};

export const DEFAULT_OPTIONS = {
  religions: ["佛道教", "基督教", "天主教", "無"],
  caseAttributes: ["一般", "金寶山", "榮服處", "仁愛之家", "聯奠", "聯合海葬", "外面禮儀公司"],
  locations: ["第一殯儀館 景行廳", "第二殯儀館 懷恩廳", "市立殯儀館 永懷廳", "自宅靈堂", "寺廟會場"],
  venueStyles: ["鮮花布置", "罐頭塔", "電子輓聯", "追思影片牆", "水晶棺", "禮堂簡約", "中式傳統", "西式教堂"],
  directors: ["林文德", "陳淑芬", "黃志明", "王美玲"],
  assistants: ["張庭瑋", "李佳穎", "吳建宏", "蔡宜君"],
  emcees: ["李宗翰", "陳雅雯", "許志豪", "林佳蓉"],
  shooters: ["周文凱", "劉冠廷", "許家豪", "鄭婉婷"],
  extras: ["人力", "水果籃", "葷三牲", "罐頭塔", "米塔", "西點", "佛祖車", "大鼓陣", "女子樂隊", "舞龍舞獅", "鋼管舞", "其他陣頭"]
};

export function emptyForm() {
  return {
    name: "",
    religion: "佛道教",
    caseAttribute: "一般",
    date: TODAY,
    location: "",
    venueStyles: [],
    extras: [],
    director: "",
    assistant: "",
    emcee: "",
    shooter: "",
    returning: false,
    note: "",
    needs: { recording: true, editing: true, photos: true }
  };
}

export const DEFAULT_CASES = [];
